<template>
  <div class="table_card">
    <div class="table_card__head">
      <v-layout row wrap>
        <v-flex lg9>
          <p class="table_card__head--title">Editar evento</p>
          <v-breadcrumbs class="breadcums">
            <v-icon slot="divider">chevron_right</v-icon>
            <v-breadcrumbs-item
              @click="$router.push({name: 'events'})"
              class="breadcums__option"
            >
              Eventos creados
            </v-breadcrumbs-item>
            <v-breadcrumbs-item
              disabled
              class="breadcums__disable"
            >
              Editar evento
            </v-breadcrumbs-item>
          </v-breadcrumbs>
        </v-flex>
        <v-flex lg3 class="filter_options">
          <v-flex class="right mr-1">
            <button
              class="faccess_button px-5"
              :disabled="formIsInError"
              @click="formIsInError?'':updateEvent()"
            >
              Actualizar
            </button>
          </v-flex>
        </v-flex>
      </v-layout>
    </div>
    <div class="table_card__info">
      <v-layout row wrap v-if="charged">
        <v-flex xs6>
        <!--   <v-flex xs12 v-if="video_published === true">
            <span class="data_card_special__info--label_form">Url video</span>
            <input
              class="trainers__form--input_form"
              type="text"
              :style="event.attributes.url.length<=0&&activeErrorName?'border-bottom:2px solid red !important;background-color:#ef4b4b59':''"
              name="Name"
              @blur="activeErrorName=true"
              placeholder="Url del video"
              v-model="event.attributes.url">
          </v-flex> -->
          <!-- Fotos de la oferta -->
          <span class="table_card__info--label">Imagen o Video</span>
          <div class="trainers__form--photo_container" v-if="!video_published">
            <label
              for="trainerPhoto"
              class="faccess_button buttom_shadow px-5">Examinar</label>
            <input
              id="trainerPhoto"
              type="file"
              accept="image/x-png,image/gif,image/jpeg"
              @change="onFileChange"
              name="logo">
            <p>{{photo_name=='manager'?'No se han seleccionado archivos':photo_name}}</p>
          </div>
          <v-flex xs12>
            <v-switch
              class="data_card_special__switch"
              :label="`Habilitar video`"
              v-model="video_published"
              color="#1476FB"
            >
            </v-switch>
          </v-flex>
          <v-flex xs12 v-if="video_published">
          <span class="table_card__info--label">Url video</span>
          <input
            class="faccess_input"
            type="text"
            :style="current_url<=0&&activeErrorName?'border:2px solid red !important;background-color:#ef4b4b19':''"
            name="Name"
            @blur="activeErrorName=true"
            placeholder="Url del video"
            v-model="current_url">
        </v-flex>
          <v-flex xs12>
            <span class="table_card__info--label">Título</span>
            <input
              class="faccess_input"
              type="text"
              :style="event.attributes.name.length<=0&&activeErrorName?'border-bottom:2px solid red !important;background-color:#ef4b4b59':''"
              name="Name"
              @blur="activeErrorName=true"
              placeholder="Título de la noticia"
              v-model="event.attributes.name">
          </v-flex>
          <v-flex xs12>
            <span style="display: block;"
            class="table_card__info--label">Contenido</span>
            <ckeditor  :editor="editor" v-model="event.attributes.description" :config="editorConfig"></ckeditor>
          </v-flex>
          <v-flex xs12>
              <span
              style="display: block; margin-top: 20px;"
              class="table_card__info--label">Fecha de evento</span>
              <app-single-date-picker
                width="100%"
                :clases="false"
                :solid="false"
                @filterQuery="changeDate($event)"
                :date_text="event.attributes.event_date">
              </app-single-date-picker>
          </v-flex>
          <v-flex xs12>
            <span
              class="table_card__info--label"
              style="display: block; margin-top: 20px;"
            >Sedes</span>
            <v-select
              label="Selecciona"
              v-bind:items="locationslist"
              :item-text="'attributes.name'"
              :item-value="'id'"
              v-model="event.attributes.location_id"
              single-line
              solo
              color="#1476FB"
            ></v-select>
          </v-flex>
          <v-flex xs12 >
            <span class="table_card__info--label">Categoría</span>
            <v-select
              label="Selecciona"
              :items="specialCategoriesList"
              :item-text="'attributes.name'"
              :item-value="'id'"
              v-model="event.attributes.special_category_id"
              single-line
              solo
              color="#1476FB"
            ></v-select>
          </v-flex>
          <v-flex xs12>
            <v-switch
              class="data_card_special__switch"
              :label="`Visible para los usuarios`"
              v-model="event.attributes.visible_to_user"
              color="#1476FB"
            >
            </v-switch>
          </v-flex>

          <v-flex xs12 style="display:flex;max-width:150%; width:150% !important; margin-top:50px;" v-if="fieldError.length>0" >
            <p style="color:red;font-size:15px">
            Complete para continuar: {{fieldError}}
            </p>
          </v-flex>

        </v-flex>

        <!-- Inicia tarjeta de la derecha -->
        <v-flex xs6 class="preview_item">
          <v-flex xs12>
            <section class="data_card_special data_card_special__instance">
              <iframe
                  v-if="event.attributes.url_type == 'video' && event.attributes.video_published && current_url != ''"
                  class="data_card_special__image"
                  :src="'https://www.youtube.com/embed/' + current_url.replace('https://youtu.be/','')+'?rel=0'"
                  frameborder="0"
                  allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                  allowfullscreen
                  style="padding-top: 0; height: 200px; max-height: 200px;"
                ></iframe>

              <div
                class="data_card_special__image"
                :style="{backgroundImage: 'url('+ url +')'}"
                v-else></div>

              <div class="data_card_special__info">
                <div class="data_card_special__info--container">
                  <p class="data_card_special__info--title_form">
                    {{event.attributes.name}}
                  </p>
                </div>
                <div class="data_card_special__info--container">
                  <span class="data_card_special__info--label_form_right">Descripción</span>
                  <p class="data_card_special__info--text_form full_text" v-html="event.attributes.description">
                    <!-- {{}} -->
                  </p>
                </div>
                <div class="data_card_special__info--container">
                  <span class="data_card_special__info--label_form_right">Es visible para los usuarios</span>
                  <span class="data_card_special__info--label_form_show">{{ event.attributes.visible_to_user ? 'Si' : 'No' }}</span>
                </div>
              </div>
            </section>
          </v-flex>
        </v-flex>
        <!-- Termina tarjeta de la derecha -->
      </v-layout>
      <div v-else>
       <v-progress-linear :indeterminate="true"></v-progress-linear>
      </div>
    </div>
    <div class="table_card__footer" v-if="charged">
      <button
        class="faccess_button px-5"
        :disabled="formIsInError"
        @click="formIsInError ? '' : updateEvent()"
      >
        Actualizar
      </button>
    </div>
  </div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export default {
  data(){
    return{
      charged:false,
      manager_url_change: false,
      schedule_url_change: false,
      schedule_url: '',
      manager_url: '',
      photo_name: 'No se han seleccionado archivos',
      activeErrorName:false,
      locationslist: '',
      specialCategoriesList: '',
      fieldError:'',
      url_change: false,
      url:'https://s3-us-west-2.amazonaws.com/karrottsportlife/default_image.svg',
      video_published: false,
      current_url: '',
      selected_category: null,
      selected_location: null,
      event:{
        attributes:{
          special_category_id: '',
          location_id: '',
          name: '',
          event_date: '',
          description: '',
          url: '',
          url_type: '',
          visible_to_user: false,
          video_published: false
        },
      },
      editor: ClassicEditor,
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {
        toolbar: {
          items: [
            'heading',
            '|',
            'bold',
            'italic',
            'Link','Unlink',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'Outdent','Indent',
           /*  '|',
            'Blockquote',
            'insertTable', */
            '|',
            'undo',
            'redo'
          ]
        },
        image: {
          toolbar: [
            'imageStyle:full',
            'imageStyle:side',
            '|',
            'imageTextAlternative'
          ]
        },
        table: {
          contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
        },
        language: 'es'
      },


    }
  },
  mounted(){
    this.findSpecialCategories();
    this.locationslist = this.getLocations();
    console.log('########### parmsEventId ########### ', this.parmsEventId )
    this.findEventById()
  },
  watch:{
    url(){
      this.url_change = true;
    },
    schedule_url(){
      // cl schedule_url
      if(this.schedule_url != ''){
        this.schedule_url_change = true;
      }
    },
    manager_url(){
      // cl manager_url
      if(this.manager_url != ''){
        this.manager_url_change = true;
      }
    },
    selected_category(){
      console.log("<--------------------------Selected Category");
      console.log(this.selected_category);
    },
    selected_location(){
      console.log("<---------------------------Selected Location");
      console.log(this.selected_location);
    },
    video_published(){
      if(this.video_published){
        this.event.attributes.url_type === 'video'
        this.event.attributes.video_published = true
      }else{
        this.event.attributes.url_type === 'img'
        this.event.attributes.video_published = false
      }
    }
  },
  computed:{
    parmsEventId: function() {
      return this.$route.params.event_id;
    },
    formIsInError(){
      var ans=false
      let fields=[]
      if(!this.url_change && this.event.attributes.name.length==0){
        fields.push("'Imagen principal o Video'")
      }
      if(this.event.attributes.name.length==0){
        fields.push("'Nombre'");
      }
      if(this.event.attributes.description.length==0){
        fields.push("'Contenido'")
      }
      if(this.event.attributes.event_date.length==0){
        fields.push("'Fecha de evento'")
      }
      if(this.event.attributes.location_id.length==0){
        fields.push("'Sede'")
      }
      if(this.event.attributes.special_category_id.length==0){
        fields.push("'Categoria'")
      }
      if(this.scheduleIsInError){
        fields.push("''")
      }
      if(fields.length>0){
        if(fields.length==2){
          this.fieldError=fields.join(" y ")
        }else{
          this.fieldError=fields.join(" , ")
        }

        ans=true
      }else{
        this.fieldError=""
      }
      return ans
    },
    scheduleIsInError(){
      var ans=false
      if(this.errorOpening||this.errorEnding||this.spacesInError){
        ans=true
      }
      return ans
    },
    // validateVideo(){
    //   if (this.event.attributes.url_type === 'video'){
    //     this.event.attributes.url_type === 'video'
    //     this.event.attributes.video_published = true
    //   } else {
    //     this.event.attributes.url_type === 'img'
    //     this.event.attributes.video_published = false
    //   }
    //   console.log('###########  this.event.attributes.url_type ################# ',  this.event.attributes.url_type)
    // },
  },
  methods:{
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      var name_field = ""+e.target.name
      if (name_field=='schedule') {
        this.schedule_url = URL.createObjectURL(files[0]);
      }else if(name_field=='manager'){
        this.manager_url = URL.createObjectURL(files[0]);
      } else {
        this.url = URL.createObjectURL(files[0]);
      }
      this.createImage(files[0], ""+e.target.name)
    },
    createImage (file, name_field) {
      var reader = new FileReader()
      var vm = this
      reader.readAsDataURL(file);
      reader.onload = function () {

        if (name_field=='schedule') {
          vm.event.attributes.schedule_image = reader.result
        }else if(name_field=='manager'){
          vm.event.attributes.manager_image = reader.result
        } else {
          //vm.location.attributes.image = reader.result
          vm.event.attributes.url = reader.result
        }
        vm.photo_name=name_field
        // vm.location.attributes.image = reader.result
      }
    },

  /*   findLocations(){
      try {
        this.$http.get('app/locations/index',{
          headers:
          {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()},
          })
        .then(function(response){
          this.locationslist = response.body.data
          console.log('this.locationslist ', this.locationslist)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    }, */
    findSpecialCategories(){
      try {
        this.$http.get('app/special_categories/index',{
          headers:
          {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()},
          })
        .then(function(response){
          this.specialCategoriesList = response.body.data
          console.log('this.specialCategoriesList ', this.specialCategoriesList)
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findEventById(){
      try {
        this.$http.get('app/events/show', {
          params:{
            id: this.parmsEventId
          },
          headers:
          {
            "X-Device-ID" : this.getDeviceId(),
            "Authorization" : 'Bearer ' + this.getUserToken()},
          })
        .then(function(response){
          this.event = response.body.data
          console.log('################ findeventById() #################### ', this.event)
          this.url = this.event.attributes.url
          this.current_url = this.event.attributes.url_type === 'video' ? this.event.attributes.url : ''
          this.event.attributes.url_type === 'video' ? this.video_published = true : this.video_published = false
          this.event.attributes.special_category_id = this.event.attributes.special_category_id.toString()
          this.event.attributes.location_id = this.event.attributes.location_id.toString()
          //URL.createObjectURL(files[0]);
          this.charged = true
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    updateEvent(){
      if(this.event.attributes.video_published === false){
        this.event.attributes.url_type = 'img'
      }else{
        this.event.attributes.url_type = 'video'
        this.event.attributes.url = this.current_url
      }

      try {
        this.$http.put('app/events/update', { data: this.encrypt(this.event).toString() },
          { headers:
            {
             "X-Device-ID" : this.getDeviceId(),
             "Authorization" : 'Bearer ' + this.getUserToken()
            },
            params:{
              id: this.parmsEventId
            }
          })
        .then(function(response){
          console.log(response);
          this.$router.push({name: 'events'})
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          console.log(response);
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        console.log(e);
        alert(e.message)
      }
    },
    changeDate(val){
      // cl val
      this.event.attributes.event_date = val
    },

  } //closed methods
}
</script>



// WEBPACK FOOTER //
// src/components/views/events/Edit_event.vue